import { Zone } from "src/interface";
import ApiService from "./ApiService";

export async function apiGetType(): Promise<Zone[]> {
  return ApiService.fetchData({
    url: `partner/type`,
    method: "get",
  }).then((res: any) => res?.data?.data as Zone[]);
}
